import React, { Component } from 'react';
import '../../inc/genstyle.css';
import DateTimeFormats from '../../inc/date-time-format';
import IHeader from './ifragmentheader';
import ISidemenu from './ifragmentsidemenu';
import INA from './ifragmentna';
import EditIcon from '@mui/icons-material/Edit';
import DescriptionIcon from '@mui/icons-material/Description';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';

const authKey = global.config.authBearerKey+"##"+global.config.kindcode[48];
  
function urladdBudget() {
    window.location.href='/iaddgcpbudget';
}

class IGCPBudgets extends Component {
  constructor(props) {
    super(props);
    this.state = {
        stTitle: '',
        pageShow: '10',
        keyword: '',
        selectType: '',
        styleTb: 'table',
        data: []
    };
    this.loadData = this.loadData.bind(this);
    this.handleKeywordChange = this.handleKeywordChange.bind(this);
  }
  
  urldeleteContent(id){
    var stat = false;
    stat = window.confirm("Are you sure you want to delete this data?");
    if(stat === true) {
      document.getElementById('loading-area').style.display = 'block'; 
        var urlString = global.config.urlLink+"/gcpbudgetdelete";
        var data = {
          docid: id,
          form_id: "delete-budget"
        }
        fetch(urlString, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': authKey,
            }, body : JSON.stringify(data)
          }).then(res => {
            if(res.status === 200) 
                return res.json() 
          }).then( resJson => {
            document.getElementById('loading-area').style.display = 'none'; 
            if(resJson.status === '200') {
                this.loadData()
            } else {
                console.log('Something happened wrong');
            }
          }).catch(err => err);
    }
  }

  handleKeywordChange(e) {
    this.setState({ keyword: e.target.value });
  }

//   loadData(keyword,pagenum,seltype) {
  loadData() {
    document.getElementById('loading-area').style.display = 'block'; 
    // Fetch budgets from herdis API backed by BigQuery
    var datatext ='{"keyword":"'+this.state.keyword+'","pageShow":"'+this.state.pageShow+'"}';
    var data = JSON.parse(datatext); 
    fetch(global.config.urlLink+"/gcpbudgetlist", {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': authKey,
        }, body : JSON.stringify(data)
    }).then(response => {
        if(response.status === 200) {
            return response.json()
        } else {
            console.log('Something happened wrong');
        }
    }).then(resJson => {
        document.getElementById('loading-area').style.display = 'none'; 
        var styleTb = 'table';
        var rows = [];
        if(resJson.status === '200' && Array.isArray(resJson.values) && resJson.values.length > 0) { 
          styleTb = 'table table-striped'; 
          // Sort by create_date desc if available
          rows = resJson.values.sort((a,b) => {
            const ad = a.create_date ? new Date(a.create_date).getTime() : 0;
            const bd = b.create_date ? new Date(b.create_date).getTime() : 0;
            return bd - ad;
          });
        }
        this.setState({
            styleTb: styleTb,
            data: rows 
        })
    }).catch(err => {
        document.getElementById('loading-area').style.display = 'none'; 
    });
  }
  
  componentDidMount() {
    // this.loadData(this.state.keyword,this.state.pageShow,this.state.selectType);
    this.loadData();
  }
    
  render() {
    var contentsList = [];
    const kw = (this.state.keyword || '').toLowerCase();
    const rowsToShow = kw
      ? this.state.data.filter(r => {
          const name = ((r.company_name || r.cuan_companyName || '') + ' ' + (r.subcompany_name || r.cuan_subcompanyName || '')).toLowerCase();
          const budgetName = (r.budget_name || '').toLowerCase();
          const doc = (r.budget_doc_id || r.docid || '').toString().toLowerCase();
          return budgetName.includes(kw) || name.includes(kw) || doc.includes(kw);
        })
      : this.state.data;
    if(rowsToShow.length > 0) {
        for(var ls=0; ls < rowsToShow.length; ls++) {
            var retResult = rowsToShow[ls];
            // Choose a robust id for routing (supports legacy rows)
            var rowId = retResult.budget_doc_id || retResult.docid || retResult.id || retResult._id || '';
            var editURL = "/ieditgcpbudget/"+rowId;
            var viewURL = "/iviewgcpbudget/"+rowId;
            const budgetVal = (retResult.currency || '') + ' ' + (retResult.budget || 0);
            const contractVal = (retResult.contract_periode || retResult.long_periode || 0) + ' month(s)';
            contentsList.push(<tr key={rowId || ls}>
                <th scope="row-field">{ls+1}</th>
                <td>{retResult.company_name || retResult.cuan_companyName || '-'}</td>
                <td>{retResult.budget_name || '-'}</td>
                <td>{budgetVal}</td>
                <td>{contractVal}</td>
                <td>
                    {rowId ? <a href={editURL}><EditIcon className="iconGrey mgR20" title="edit" /></a> : <EditIcon className="iconGreyDis mgR20" title="edit" />}
                    {rowId ? <a href={viewURL}><DescriptionIcon className="iconGrey mgR20" title="view"/></a> : <DescriptionIcon className="iconGreyDis mgR20" title="view"/>}
                    {rowId && localStorage.getItem('ulevel') === global.config.userlevel[0]? <DeleteIcon className="iconGrey mgR20" title="delete" onClick={this.urldeleteContent.bind(this, rowId)}/> : ''}
                </td>
              </tr>)
        }
    } else {
        contentsList.push(<tr key="1">
            <td colSpan="6" className="textCenter"><div className="mgT20 mgB20">:: no record ::</div></td>
          </tr>)
    }

   return (
    <div className="main-container">
      <div  className="header-main"><IHeader/></div>
          <div className="flex-container">
              <div className="sidebar-main"><ISidemenu/></div>
              <div className="main-content">
                <div className="stTitle">Client's Budget GCP</div>
                {((localStorage.getItem('ulevel') === global.config.userlevel[0]) || (JSON.parse(localStorage.getItem('urole'))[9] === "ON"))? 
                <div>
                    <div className="stIndiTitle">List of Client's Google Cloud Platform Billing Budget</div>
                    <div className="mgT30">
                        {/*--*/}
                        <div className="content-container card card-body">
                            <div className="row show">
                                <div className="col-6 divMiddle">
                                    <div className="form-inline">
                                      <SearchIcon className="iconGrey mgR10" />
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search budget name..."
                                        value={this.state.keyword}
                                        onChange={this.handleKeywordChange}
                                      />
                                    </div>
                                </div>
                                <div className="col-6 form-inline justify-content-end">
                                    <button className="genButton mgL20" onClick={urladdBudget}><AddCircleOutlineIcon className="iconWhite mgR05"></AddCircleOutlineIcon>Add New Budget</button>
                                </div>
                            </div>
                            <div className="row-field mgT20">
                                <table className={this.state.styleTb}>
                                <thead>
                                    <tr key="0">
                                    <th scope="col">#</th>
                                    <th scope="col">Client Name</th>
                                    <th scope="col">Budget Name</th>
                                    <th scope="col">Budget</th>
                                    <th scope="col">Contract Periode</th>
                                    <th scope="col" style={{width:"180px"}}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {contentsList}
                                </tbody>
                                </table>
                            </div>
                           
                        </div>
                        {/*--*/}
                    </div>
                </div>
                :   
                <div><INA/></div>
                }
              </div>
          </div>
          <div id="loading-area" className="divHide loading"></div>
    </div>
   );
  }
}
 
export default IGCPBudgets;